<prlw-layout>
  <router-outlet prlwRouterOutlet></router-outlet>
  <prlw-preloader-circle></prlw-preloader-circle>
</prlw-layout>
<prlw-check-active-subscriptions></prlw-check-active-subscriptions>
